import Vue from 'vue'
import Vuetify from 'vuetify'
import VueClipboard from 'vue-clipboard2'
import VueHotkey from 'v-hotkey'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import helpers from '@/utils/helpers'

import 'vuetify/dist/vuetify.css'
import '@/styles/App.scss'
import '@/registerServiceWorker'

// Vue config and plugins
Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(VueHotkey)
Vue.use(Vuetify, {
  theme: {
    primary: '#5b5dff' // blue-isabl
    // primary: '#1c75cd' // blue-msk
    // primary: '#064785' // blue-msk-dark
    // primary: '#08854c' // other-green
  },
  options: {
    minifyTheme: (css) => {
      return process.env.NODE_ENV === 'production'
        ? css.replace(/[\s|\r\n|\r|\n]/g, '')
        : css
    }
  }
})

// Filters are available as helpers in the templates like {{ param | filter }}
Vue.filter('camelify', helpers.camelify)
Vue.filter('formatNumber', helpers.formatNumber)
Vue.filter('formatDate', helpers.formatDate)
Vue.filter('formatSize', helpers.formatSize)
Vue.filter('truncate', helpers.truncate)
Vue.filter('round', helpers.round)

// Instance methods and properties are available in each Vue instance
Vue.prototype.$camelify = helpers.camelify
Vue.prototype.$unslugify = helpers.unslugify
Vue.prototype.$get = helpers.get
Vue.prototype.$set = helpers.set
Vue.prototype.$contains = helpers.contains
Vue.prototype.$remove = helpers.remove
Vue.prototype.$formatSize = helpers.formatSize
Vue.prototype.$user = window.USER || {}

const IsablWeb = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#isabl-web')

export default IsablWeb
